import { Table, Text, Tag, Icon, Box } from '@nimbus-ds/components';
import { StarIcon } from '@nimbus-ds/icons';
import { generatePath, Link } from 'react-router-dom';
import { ProductTransferListResponseDto } from '@tiendanube/common';
import { dateFormat, Format } from 'commons/utils/date';
import { CATALOG_ROUTES } from 'domains/Catalog/catalogRoutes';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { TransferStatus } from 'domains/Catalog/Transfers/pages/components';
import TransferListRowSkeleton from './TransferListRowSkeleton';

interface TransferListRowProps {
  transfer: ProductTransferListResponseDto[number];
}

function TransferListRow({
  transfer: {
    id,
    number,
    originLocation,
    originIsMain,
    destinationLocation,
    destinationIsMain,
    transferDate,
    status,
  },
}: Readonly<TransferListRowProps>) {
  const t = useTranslationCatalog('transfers.list');

  const location = (location: string, isMain: boolean) => (
    <Box display="flex" gap="2">
      <Text>{location}</Text>
      {isMain && (
        <Tag appearance="primary">
          <Icon source={<StarIcon />} />
          {t('main')}
        </Tag>
      )}
    </Box>
  );

  return (
    <Table.Row>
      <Table.Cell>
        <Link
          className="nimbus--link nimbus--link--primary nimbus--link--base"
          to={generatePath(CATALOG_ROUTES.viewTransferDetails, { id })}
        >
          #{number}
        </Link>
      </Table.Cell>
      <Table.Cell>{location(originLocation, originIsMain)}</Table.Cell>
      <Table.Cell>
        {location(destinationLocation, destinationIsMain)}
      </Table.Cell>
      <Table.Cell>
        <Text>{dateFormat(transferDate, Format.DAY_MONTH)}</Text>
      </Table.Cell>
      <Table.Cell>
        <TransferStatus status={status} />
      </Table.Cell>
    </Table.Row>
  );
}

TransferListRow.Skeleton = TransferListRowSkeleton;

export default TransferListRow;
